import {
  createAsyncThunk,
  createSlice,
  injectSlice,
} from '@betty/toolkit/state';
import DetailsAttestationService from '../service/DetailsAttestationService';
import {
  AccountAttestationPayload,
  ReassessedAccountState,
} from './detailsAttestation.types';

export const reassessAccount = createAsyncThunk(
  'account/reassessAccount',
  async (assessmentData?: AccountAttestationPayload) => {
    const requestData = {
      hasAccountChanges: !!assessmentData,
      firstName: assessmentData?.firstName,
      lastName: assessmentData?.lastName,
      addressLine1: assessmentData?.address,
      city: assessmentData?.city,
      provinceCode: assessmentData?.provinceCode,
      postalCode: assessmentData?.postalCode,
      occupation: assessmentData?.occupation,
      phoneCode: assessmentData?.phoneCode,
      phoneNumber: assessmentData?.phoneNumber,
      isPep: !assessmentData?.pepCheck,
    };
    return await DetailsAttestationService.reassessAccount({
      data: requestData,
    });
  },
);

const initialState: ReassessedAccountState = {
  reassessmentDataState: 'idle',
};

const detailsAttestation = createSlice({
  name: 'detailsAttestation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(reassessAccount.pending, (state) => {
      state.reassessmentDataState = 'pending';
    });

    builder.addCase(reassessAccount.fulfilled, (state) => {
      state.reassessmentDataState = 'fulfilled';
    });

    builder.addCase(reassessAccount.rejected, (state) => {
      state.reassessmentDataState = 'rejected';
    });
  },
});

const withDetailsAttestation = injectSlice({
  reducerPath: 'detailsAttestation',
  reducer: detailsAttestation.reducer,
});

export const selectReassessmentDataState = withDetailsAttestation.selector(
  (state) => state.detailsAttestation.reassessmentDataState,
);

declare global {
  interface LazyLoadedSlices {
    detailsAttestation: ReturnType<typeof detailsAttestation.reducer>;
  }
}
